<template>
  <div class="component">
    <div class="component-title">现在用车订单取消规则</div>
    <div style="font-size: 12px;line-height: 28px;color: #85807B;">根据订单不同的运输状态所产生的实际运输成本不同，我们将对取消的订单收取部分费用</div>
    <table style="margin-bottom: 8px;font-size: 12px;">
      <tbody>
        <tr>
          <th width="30%">运输状态</th>
          <th colspan="2">取消成本</th>
        </tr>
        <tr>
          <td width="30%" style="font-size: 14px;">未接单</td>
          <td colspan="2" style="color:#EC892E;">免费取消</td>
        </tr>
        <tr>
          <td width="30%" rowspan="3">出发后完成装货前</td>
          <td>接单5分钟内</td>
          <td>{{carAttributeFeeConfig.customerFastCancelOrderRule? carAttributeFeeConfig.customerFastCancelOrderRule.ltFiveMinutes:'--'}}元</td>
        </tr>
        <tr>
          <td>接单5~10分钟内</td>
          <td>{{carAttributeFeeConfig.customerFastCancelOrderRule? carAttributeFeeConfig.customerFastCancelOrderRule.betweenFiveAndTenMinutes:'--'}}元</td>
        </tr>
        <tr>
          <td>接单10分钟后</td>
          <td>{{carAttributeFeeConfig.customerFastCancelOrderRule? carAttributeFeeConfig.customerFastCancelOrderRule.gtTenMinutes:'--'}}元</td>
        </tr>
      </tbody>
    </table>
    <!-- <table style="font-size: 12px;">
      <tbody>
        <tr>
          <th colspan="2">到达提货地已装货未卸货</th>
        </tr>
        <tr>
          <td width="50%">已运输里程界限</td>
          <td style="color:#EC892E;">{{carAttributeFeeConfig.chargebackMeileageLimit}}公里</td>
        </tr>
        <tr>
          <td>未超过里程界限扣款</td>
          <td>{{carAttributeFeeConfig.chargebackMeileageRatio}}%</td>
        </tr>
        <tr>
          <td>超过里程界限扣款</td>
          <td>{{carAttributeFeeConfig.chargebackRatio?Number( math(100,carAttributeFeeConfig.chargebackRatio).subtract()):'--'}}%</td>
        </tr>
        <tr>
          <td>超过里程界限退单基数</td>
          <td>{{carAttributeFeeConfig.chargebackBase}}元</td>
        </tr>
      </tbody>
    </table> -->
  </div>
</template>

<script>
import { $math } from "@/utils/math.js";

export default {
  name:"LoadingUnloadingFee",
  props:{
    carAttributeFeeConfig:{
      type:Object,
      default:()=>{
        return {
          fastOrderCancelTransportOrderRule:{},
        }
      }
    }
  },
  data(){
    return {
      bulkCargoFeeTypeOptions:{
        complete:"整车",
        half:"半车",
        none:"默认"
      },
      math:$math
    }
  }
}
</script>

<style scoped lang="scss">
 table,
th,
td {
  border: 1px solid #C9C2BB;
}

table {
  width: 100%;
  margin: 0 auto;
  display: table;
  border-spacing: 0;
  border-radius: 4px;
  overflow: hidden;
}
th,
td {
  border-top-width: 0;
  border-left-width: 0;
  text-align: center;
}

th:last-child,
td:last-child {
  border-right-width: 0;
}

tr:last-child td {
  border-bottom-width: 0;
}

tr {
  height: 40px;
}
td tr td{
  border-top: 1px solid #C9C2BB;
}
td tr:first-child td {
  border-top: 0;
  border-bottom: 0;
}
table tbody > tr > th {
  background-color: #F8F8F8;
  color:#3D3833;
  font-weight: 500;
}
</style>